import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import GameCard from '../../components/GameCard/GameCard';
import Image_slider from '../../components/ImageSlider/Image_slider';
import AdCMP from '../../components/ADS/AdCMP';

function GamesPreview() {
    const { name } = useParams();
    const [state, setState] = useState([]);
    const [gamesList, setGamesList] = useState([]);
    const [OnPreview, setOnPreview] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const slugify = (text) => text?.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') || ''

    const getGameListFunc = async () => {
        try {
            const api_res = await axios.get("https://pub.gamezop.com/v3/games?id=9632&lang=en");
            const games = api_res?.data?.games || [];
            setGamesList(games)
            const New_Data = games.filter((item) => slugify(item?.name?.en) === name);
            setState(New_Data[0] || null);
        } catch (error) {
        }
    };

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };

    const exitFullscreen = () => {
        setIsFullscreen(false);
    };

    const shareGame = () => {
        if (navigator.share) {
            navigator.share({
                title: `${state?.name?.en} - Play Online for Free!`,
                text: `Play ${state?.name?.en} on Vibe of Games!`,
                url: window.location.href
            });
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Game link copied to clipboard!');
        }
    };

    useEffect(() => {
        getGameListFunc();
        setOnPreview(false)
    }, [name]);

    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [state]);

    function formatNumber(num) {
        if (!num || num === 0) return "0";
        if (num >= 1e9) {
            return (num / 1e9).toFixed(2) + "B";
        } else if (num >= 1e6) {
            return (num / 1e6).toFixed(2) + "M";
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(2) + "K";
        }
        return num.toString();
    }

    return (
        <div className='relative'>
            {state?.url && (
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="theme-color" content="#F4F4F4" />
                    <meta name="apple-mobile-web-app-capable" content="yes" />
                    <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                    <meta name="apple-mobile-web-app-title" content="Vibe of Games" />
                    <meta name="HandheldFriendly" content="true" />
                    <meta name="mobile-web-app-capable" content="yes" />
                    <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, minimal-ui, shrink-to-fit=no, viewport-fit=cover" />

                    <title>{state?.name?.en} - Play Online for Free! | Vibe of Games</title>
                    <meta name="title" content={`${state?.name?.en} - Play Online for Free! | Vibe of Games`} />
                    <meta name="description" content={`Play ${state?.name?.en} on Vibe of Games – your ultimate hub for free online gaming! Enjoy top action, adventure, arcade, and puzzle games with no downloads or logins required!`} />
                    <meta name="keywords" content={`play free online games, ${state?.name?.en} online game, best HTML5 games, action games, arcade games, puzzle games, multiplayer games, Vibe of Games`} />
                    <meta name="author" content="Vibe of Games" />
                    <meta name="robots" content="index, follow" />

                    <meta property="og:title" content={`${state?.name?.en} - Play Online for Free! | Vibe of Games`} />
                    <meta property="og:description" content={`Play ${state?.name?.en} on Vibe of Games – your ultimate hub for free online gaming! Enjoy top action, adventure, arcade, and puzzle games with no downloads or logins required!`} />
                    <meta property="og:url" content="https://vibeofgames.com/gameplay/${state?.slug}" />
                    <meta property="og:site_name" content="Vibe of Games" />
                    <meta property="og:image" content={`https://vibeofgames.com/assets/images/game-thumbnails/${state?.assets?.square}`} />
                    <meta property="og:type" content="website" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${state?.name?.en} - Play Online for Free! | Vibe of Games`} />
                    <meta name="twitter:description" content={`Play ${state?.name?.en} on Vibe of Games – your ultimate hub for free online gaming! Enjoy top action, adventure, arcade, and puzzle games with no downloads or logins required!`} />
                    <meta name="twitter:image" content={`https://vibeofgames.com/assets/images/game-thumbnails/${state?.assets?.square}`} />

                    <link rel="canonical" href={`https://vibeofgames.com/gameplay/${state?.name?.en}`} />
                </Helmet>
            )}

            {/* Fullscreen Modal */}
            {isFullscreen && (
                <div className="fixed inset-0 z-50 bg-black flex items-center justify-center">
                    <button
                        onClick={exitFullscreen}
                        className="absolute top-4 left-4 z-60 bg-red-500 hover:bg-red-600 text-white p-3 rounded-full transition-colors duration-300 shadow-lg"
                    >
                        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                    </button>
                    <iframe
                        src={state?.url}
                        className="w-full h-full"
                        title={state?.name?.en}
                    />
                </div>
            )}

            <div className='p-2 sm:p-3 sm:ml-56'>
                {/* Game Header with Info */}
                <div className="mt-16 sm:mt-14 mb-3">
                    <div className="bg-gradient-to-r from-purple-600 via-pink-600 to-blue-600 rounded-xl p-3 sm:p-4 text-white relative overflow-hidden">
                        <div className="absolute inset-0 bg-black/20"></div>
                        <div className="relative z-10">
                            <div className="flex items-center gap-3 sm:gap-4">
                                <img
                                    src={state?.assets?.square}
                                    alt={state?.name?.en}
                                    className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg shadow-lg border border-white/30"
                                />
                                <div className="flex-1">
                                    <h1 className="text-lg sm:text-xl lg:text-2xl font-bold mb-1">{state?.name?.en}</h1>
                                    <div className="flex flex-wrap gap-2 mb-1">
                                        {state?.categories?.en?.slice(0, 3)?.map((category, index) => (
                                            <span key={index} className="bg-white/20 px-2 py-1 rounded-full text-xs font-medium">
                                                {category}
                                            </span>
                                        ))}
                                    </div>
                                    <div className="flex items-center gap-4 text-sm">
                                        <span className="opacity-75">Plays: <span className="font-bold text-yellow-300">{formatNumber(state?.gamePlays || 0)}</span></span>
                                        {state?.isPortrait !== undefined && (
                                            <span className="opacity-75">{state?.isPortrait ? "Portrait" : "Landscape"}</span>
                                        )}
                                    </div>
                                </div>
                                {state?.tags?.en?.length > 0 && (
                                    <div className="hidden lg:flex flex-wrap gap-1 max-w-xs">
                                        {state?.tags?.en?.slice(0, 4)?.map((tag, index) => (
                                            <span key={index} className="bg-white/20 text-white px-2 py-1 rounded-full text-xs font-medium">
                                                {tag}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Game Content */}
                <div className="grid grid-cols-1 xl:grid-cols-4 gap-3 sm:gap-4">
                    {/* Game Player */}
                    <div className="xl:col-span-3">
                        <div className="bg-gradient-to-br from-gray-900 via-purple-900 to-black rounded-2xl p-3 sm:p-4 shadow-xl">
                            <div className="aspect-square sm:aspect-video bg-black rounded-xl relative overflow-hidden">
                                {OnPreview ? (
                                    <div className="relative w-full h-full">
                                        <iframe
                                            src={state?.url}
                                            className="w-full h-full rounded-2xl"
                                            title={state?.name?.en}
                                        />
                                        <button
                                            onClick={toggleFullscreen}
                                            className="absolute top-4 right-4 bg-black/50 hover:bg-black/70 text-white p-2 rounded-lg transition-colors duration-300"
                                        >
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M3 4a1 1 0 011-1h4a1 1 0 010 2H6.414l2.293 2.293a1 1 0 11-1.414 1.414L5 6.414V8a1 1 0 01-2 0V4zm9 1a1 1 0 010-2h4a1 1 0 011 1v4a1 1 0 01-2 0V6.414l-2.293 2.293a1 1 0 11-1.414-1.414L13.586 5H12zm-9 7a1 1 0 012 0v1.586l2.293-2.293a1 1 0 111.414 1.414L6.414 15H8a1 1 0 010 2H4a1 1 0 01-1-1v-4zm13-1a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 010-2h1.586l-2.293-2.293a1 1 0 111.414-1.414L15 13.586V12a1 1 0 011-1z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-purple-900/50 to-pink-900/50 backdrop-blur-sm">
                                        <div className="text-center text-white">
                                            <img
                                                src={state?.assets?.square}
                                                alt={state?.name?.en}
                                                className="w-24 h-24 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-3 rounded-xl shadow-xl"
                                            />
                                            <h3 className="text-xl sm:text-lg font-bold mb-4 sm:mb-3">{state?.name?.en}</h3>
                                            <button
                                                onClick={() => setOnPreview(true)}
                                                className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 text-white px-6 sm:px-4 py-3 sm:py-2 rounded-xl font-bold text-base sm:text-sm flex items-center gap-2 mx-auto transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-purple-500/50"
                                            >
                                                <svg className="w-5 h-5 sm:w-4 sm:h-4" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                                                </svg>
                                                Play Now
                                            </button>

                                            <div className="text-center mt-4 sm:mt-3">
                                                <ins
                                                    className="adsbygoogle"
                                                    style={{
                                                        display: "inline-block",
                                                        width: "300px",
                                                        height: "100px",
                                                    }}
                                                    data-ad-client="ca-pub-8383910619750608"
                                                    data-ad-slot="6200935433"
                                                ></ins>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Game Controls */}
                            <div className="flex justify-end items-center mt-2 sm:mt-3 text-white text-sm">
                                <div className="flex gap-2">
                                    <button
                                        onClick={shareGame}
                                        className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors duration-300"
                                        title="Share Game"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
                                        </svg>
                                    </button>
                                    <button
                                        className="bg-white/10 hover:bg-white/20 p-2 rounded-lg transition-colors duration-300"
                                        title="Add to Favorites"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>



                        {/* In-Game Ad */}
                        <div className="mt-4 bg-gradient-to-r from-cyan-50 to-blue-50 dark:from-cyan-900/20 dark:to-blue-900/20 rounded-xl p-4 border border-cyan-200 dark:border-cyan-700">
                            <div className="text-center mb-3">
                                <span className="text-sm text-cyan-600 dark:text-cyan-400 font-medium flex items-center justify-center">
                                    <span className="mr-2">⚡</span>
                                    Quick Break
                                    <span className="ml-2">⚡</span>
                                </span>
                            </div>
                            <div className='flex justify-center'>
                                <div className='hidden lg:block'>
                                    <AdCMP adSize='728x90' dataAdSlot="6950599574" />
                                </div>
                                <div className='block lg:hidden'>
                                    <AdCMP adSize='320x50' dataAdSlot="6950599574" />
                                </div>
                            </div>
                        </div>

                        {/* Game Screenshots */}
                        <div className="mt-3 sm:mt-4">
                            <Image_slider screens={state?.assets?.screens} main={false} />
                        </div>
                    </div>

                    {/* Sidebar */}
                    <div className="xl:col-span-1 space-y-4">
                        {/* Top Sidebar Ad */}
                        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-3 border border-blue-200 dark:border-blue-700 shadow-sm">
                            <div className="text-center mb-3">
                                <span className="text-xs text-blue-600 dark:text-blue-400 font-medium flex items-center justify-center">
                                    <span className="mr-1">💎</span>
                                    Premium
                                </span>
                            </div>
                            <AdCMP adSize='300x250' dataAdSlot="6950599574" />
                        </div>

                        {/* Game Recommendations */}
                        <div className="bg-gradient-to-br from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-4 border border-purple-200 dark:border-purple-700">
                            <h3 className="font-bold text-purple-900 dark:text-purple-100 mb-3 flex items-center">
                                <span className="text-lg mr-2">🎯</span>
                                Recommended
                            </h3>
                            <div className="space-y-3">
                                {gamesList?.slice(0, 3)?.map((_ele, i) => {
                                    if (!_ele?.name?.en) return null;
                                    const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                                    return (
                                        <a key={i} href={`/game/${GetSlug}`} className="flex items-center space-x-3 p-2 bg-white dark:bg-gray-800 rounded-lg hover:bg-purple-50 dark:hover:bg-purple-900/20 transition-colors duration-300 group">
                                            <img
                                                src={_ele?.assets?.square}
                                                alt={_ele?.name?.en}
                                                className="w-10 h-10 object-cover rounded group-hover:scale-110 transition-transform duration-300"
                                            />
                                            <span className="text-sm font-medium text-gray-900 dark:text-white group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors duration-300 truncate">
                                                {_ele?.name?.en}
                                            </span>
                                        </a>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Vertical Ad */}
                        <div className="hidden lg:block bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 rounded-xl p-3 border border-green-200 dark:border-green-700">
                            <div className="text-center mb-3">
                                <span className="text-xs text-green-600 dark:text-green-400 font-medium flex items-center justify-center">
                                    <span className="mr-1">🎮</span>
                                    More Games
                                </span>
                            </div>
                            <AdCMP adSize='300x600' dataAdSlot="2373786665" />
                        </div>
                    </div>
                </div>

                {/* Mid-Content Ad */}
                <div className="my-6 bg-gradient-to-r from-yellow-50 via-orange-50 to-red-50 dark:from-yellow-900/10 dark:via-orange-900/10 dark:to-red-900/10 rounded-2xl p-4 border border-orange-200 dark:border-orange-700 shadow-lg">
                    <div className="text-center mb-4">
                        <span className="text-sm text-orange-600 dark:text-orange-400 font-medium flex items-center justify-center">
                            <span className="mr-2">🌟</span>
                            Featured Content
                            <span className="ml-2">🌟</span>
                        </span>
                    </div>
                    <div className='flex justify-center'>
                        <div className='hidden xl:block'>
                            <AdCMP adSize='1200x280' dataAdSlot="6200935433" />
                        </div>
                        <div className='hidden lg:block xl:hidden'>
                            <AdCMP adSize='1000x280' dataAdSlot="6200935433" />
                        </div>
                        <div className='hidden md:block lg:hidden'>
                            <AdCMP adSize='744x280' dataAdSlot="6200935433" />
                        </div>
                        <div className='block md:hidden'>
                            <AdCMP adSize='300x250' dataAdSlot="6200935433" />
                        </div>
                    </div>
                </div>

                {/* Related Games */}
                <div className='mt-8'>
                    <h2 className='text-black dark:text-white font-bold text-lg sm:text-xl lg:text-2xl flex items-center mb-3 sm:mb-4'>
                        <span className='text-xl sm:text-2xl mr-2'>🎮</span>
                        <span className='bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent'>More Games Like This</span>
                    </h2>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-2 sm:gap-3">
                        {gamesList && gamesList?.slice(30, 60)?.map((_ele, i) => {
                            if (!_ele?.name?.en) return null;
                            const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                            return (
                                <GameCard key={i} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
                            );
                        })}
                        {gamesList.length === 0 && (
                            <div className="col-span-full rounded-lg bg-white dark:bg-gray-800 w-full h-40 flex justify-center items-center my-4">
                                <h3 className='text-xl font-bold text-gray-600 dark:text-gray-300'>
                                    No games found.
                                </h3>
                            </div>
                        )}
                    </div>
                </div>

                {/* Bottom Ad - Call to Action */}
                <div className="my-6 bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 dark:from-indigo-900/10 dark:via-purple-900/10 dark:to-pink-900/10 rounded-2xl p-6 border border-purple-200 dark:border-purple-700 shadow-xl">
                    <div className="text-center mb-6">
                        <h3 className="text-lg font-bold text-purple-900 dark:text-purple-100 mb-2 flex items-center justify-center">
                            <span className="mr-2">🎁</span>
                            Discover More Amazing Games
                            <span className="ml-2">🎁</span>
                        </h3>
                        <p className="text-sm text-purple-600 dark:text-purple-400">Play hundreds of free games instantly!</p>
                    </div>
                    <div className='flex justify-center'>
                        <div className='hidden xl:block'>
                            <AdCMP adSize='1200x280' dataAdSlot="4229378215" />
                        </div>
                        <div className='hidden lg:block xl:hidden'>
                            <AdCMP adSize='1000x280' dataAdSlot="4229378215" />
                        </div>
                        <div className='hidden md:block lg:hidden'>
                            <AdCMP adSize='744x280' dataAdSlot="4229378215" />
                        </div>
                        <div className='block md:hidden'>
                            <AdCMP adSize='300x250' dataAdSlot="4229378215" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GamesPreview;